import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isAnalyzeContentDisabledForPrivacy } from "owa-privacy-utils/lib/selectors/isAnalyzeContentDisabledForPrivacy";
import { isServiceRequestSupportedForMailbox } from "owa-service/lib/utils/isServiceRequestSupportedForMailbox";
import { isMailboxSharedOrDelegate } from "owa-account-shared-mailbox-utils";
import type { CopilotEnablementDiagnostics } from "./enablementCodes/CopilotEnablementTypes";
import { CopilotFeatureEnablementCodes } from "./enablementCodes/CopilotFeatureEnablementCodes";
import { getApplicationSettings } from "owa-application-settings";
import { getUnifiedInboxResolvedMailboxInfoOrSelf } from "owa-session-store";

export function shouldDisableCopilot(mailboxInfo: MailboxInfo, diagnostics?: CopilotEnablementDiagnostics): boolean {
    // Handle UIB by considering the real mailboxInfo that will be used for copilot
    const effectiveMailboxInfo = getUnifiedInboxResolvedMailboxInfoOrSelf(mailboxInfo);
    
    // Respect the privacy settings based on the global(primary) mailbox
    if (isAnalyzeContentDisabledForPrivacy()) {
        diagnostics &&
            (diagnostics.code = CopilotFeatureEnablementCodes.COPILOT_DISABLED_PRIVACY_POLICY);
        return true;
    }
    
    // Global killswitch
    if (getApplicationSettings("Copilot").disableCopilot === true) {
        return true;
    }
    
    return shouldDisableCopilotBasedOnMailbox(effectiveMailboxInfo, diagnostics);
}

export function shouldDisableCopilotBasedOnMailbox(mailboxInfo: MailboxInfo, diagnostics?: CopilotEnablementDiagnostics): boolean {
    const isArchiveMailbox = mailboxInfo.type === "ArchiveMailbox";
    const isMailboxSharedOrDelegateResult = !isGlobalFeatureEnabled("acct-enable-shared-in-bizchat") &&
        isMailboxSharedOrDelegate(mailboxInfo); // Disable copilot for shared and delegate mailboxes if the flight to enable is off
    const isServiceRequestSupported = isServiceRequestSupportedForMailbox(mailboxInfo);
    
    if (diagnostics) {
        if (isArchiveMailbox) {
            diagnostics.code = CopilotFeatureEnablementCodes.COPILOT_DISABLED_ARCHIVE_MAILBOX;
        }
        else if (isMailboxSharedOrDelegateResult) {
            diagnostics.code =
                CopilotFeatureEnablementCodes.COPILOT_DISABLED_SHARED_OR_DELEGATE_MAILBOX;
        }
        else if (!isServiceRequestSupported) {
            diagnostics.code =
                CopilotFeatureEnablementCodes.COPILOT_DISABLED_SERVICE_REQUEST_UNSUPPORTED_FOR_MAILBOX;
        }
    }
    
    return (isArchiveMailbox ||
        isMailboxSharedOrDelegateResult || // Disable copilot for shared and delegate mailboxes
        !isServiceRequestSupported);
}
